import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/articles.js'), 'articles.js')
  resolveStoreModules(require('../store/auth.js'), 'auth.js')
  resolveStoreModules(require('../store/author.js'), 'author.js')
  resolveStoreModules(require('../store/breadcrumbs.js'), 'breadcrumbs.js')
  resolveStoreModules(require('../store/categories.js'), 'categories.js')
  resolveStoreModules(require('../store/cmp.js'), 'cmp.js')
  resolveStoreModules(require('../store/countries.js'), 'countries.js')
  resolveStoreModules(require('../store/directory.js'), 'directory.js')
  resolveStoreModules(require('../store/dom.js'), 'dom.js')
  resolveStoreModules(require('../store/element-visibility.js'), 'element-visibility.js')
  resolveStoreModules(require('../store/errors.js'), 'errors.js')
  resolveStoreModules(require('../store/events.js'), 'events.js')
  resolveStoreModules(require('../store/globalSearch.js'), 'globalSearch.js')
  resolveStoreModules(require('../store/intelligence.js'), 'intelligence.js')
  resolveStoreModules(require('../store/joditReadyState.js'), 'joditReadyState.js')
  resolveStoreModules(require('../store/layouts.js'), 'layouts.js')
  resolveStoreModules(require('../store/leads.js'), 'leads.js')
  resolveStoreModules(require('../store/media.js'), 'media.js')
  resolveStoreModules(require('../store/modal.js'), 'modal.js')
  resolveStoreModules(require('../store/monday.js'), 'monday.js')
  resolveStoreModules(require('../store/mutation-types.js'), 'mutation-types.js')
  resolveStoreModules(require('../store/notifications.js'), 'notifications.js')
  resolveStoreModules(require('../store/router.js'), 'router.js')
  resolveStoreModules(require('../store/seo.js'), 'seo.js')
  resolveStoreModules(require('../store/tag.js'), 'tag.js')
  resolveStoreModules(require('../store/terms.js'), 'terms.js')
  resolveStoreModules(require('../store/third-parties.js'), 'third-parties.js')
  resolveStoreModules(require('../store/videos.js'), 'videos.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
